import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

import VCalendar from 'v-calendar';

// Bootstrap & Bootstrap Vue
import { BootstrapVue } from 'bootstrap-vue';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Other Styles
import 'vueperslides/dist/vueperslides.css';
import './assets/css/tables.min.css';
import './assets/css/style.min.css';
import './assets/css/vendors.css';
import './assets/css/custom.min.css';
import './assets/css/icon_fonts/css/all_icons.min.css';
import './assets/css/icon_fonts/fontawesome/css/all.min.css';

// VueCroppie use on Profile Image
import VueCroppie from 'vue-croppie';
import './assets/css/croppie.min.css';

// GoogleMaps
import * as VueGoogleMaps from 'vue2-google-maps';

// VueScrollTo  - use to scroll pages
import VueScrollTo from 'vue-scrollto';

// VueSocialChat  - link to whatsapp
import VueSocialChat from 'vue-social-chat';

import store from './stores/store';
import i18n from './lang';
import App from './App.vue';
import router from './router';

Vue.use(VCalendar, {
  componentPrefix: 'v',
});

window.$ = window.jQuery = require('jquery');

Vue.use(BootstrapVue);
let params = {};
if (store.state.main.user_id) {
  params = {
    user_id: store.state.main.user_id,
  };
}

Vue.use(VueCroppie);

Vue.use(VueAxios, axios);
Vue.config.productionTip = false;
Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    libraries: 'places',
  },

  installComponents: true, // TODO: Optimize installing componentes manually
});
Vue.use(VueScrollTo, {
  cancelable: false,
  offset: -70,
});
Vue.use(VueSocialChat);

Vue.prototype.$globalCategories = {
  travel_agency: 'fas fa-plane',
  cafe: 'fas fa-utensils',
  payment_center: 'fas fa-money-check-alt',
  coworking: 'fas fa-business-time',
  pharmacy: 'fas fa-medkit',
  hotel: 'fas fa-hotel',
  hostel: 'fas fa-bed',
  ice_cream_shop: 'fas fa-ice-cream',
  bookstore: 'fas fa-book',
  shipping_center: 'fas fa-truck',
  market: 'fas fa-shopping-basket',
  store: 'fas fa-shopping-bag',
  other: 'fas fa-store',
};

Vue.prototype.$globalHomeCategories = {
  travel_agency: 'fas fa-plane',
  cafe: 'fas fa-utensils',
  payment_center: 'fas fa-money-check-alt',
  coworking: 'fas fa-business-time',
  hotel: 'fas fa-hotel',
  hostel: 'fas fa-bed',
  ice_cream_shop: 'fas fa-ice-cream',
  bookstore: 'fas fa-book',
  store: 'fas fa-shopping-bag',
};

Vue.prototype.$globalPrices = {
  ARS: {
    first_bag: process.env.VUE_APP_PRICE_ARS_FIRST_BAG,
    add_bags: process.env.VUE_APP_PRICE_ARS_ADD_BAGS,
    symbol: 'ARS $',
  },
  BRL: {
    first_bag: 32,
    add_bags: 28,
    symbol: 'BRL R$',
  },
  CLP: {
    first_bag: 5700,
    add_bags: 4750,
    symbol: 'CLP $',
  },
  COP: {
    first_bag: 21600,
    add_bags: 18000,
    symbol: 'COP $',
  },
  CRC: {
    first_bag: 3060,
    add_bags: 2550,
    symbol: 'CRC ₡',
  },
  DOP: {
    first_bag: 390,
    add_bags: 325,
    symbol: 'DOP $',
  },
  EUR: {
    first_bag: 6,
    add_bags: 5,
    symbol: 'EUR €',
  },
  GBP: {
    first_bag: 5,
    add_bags: 4,
    symbol: 'GBP £',
  },
  MXN: {
    first_bag: 105,
    add_bags: 90,
    symbol: 'MXN $',
  },
  PEN: {
    first_bag: 22,
    add_bags: 18,
    symbol: 'PEN S/',
  },
  USD: {
    first_bag: 6,
    add_bags: 5,
    symbol: 'USD $',
  },
  UYU: {
    first_bag: 250,
    add_bags: 200,
    symbol: 'UYU $',
  },
};

Vue.prototype.$currencyByCountry = {
  AR: 'ARS',
  BR: 'BRL',
  CO: 'COP',
  MX: 'MXN',
  CL: 'CLP',
  DO: 'DOP',
  CR: 'CRC',
  PE: 'PEN',
  UY: 'UYU',
  ES: 'EUR',
  IT: 'EUR',
  GB: 'GBP',
  US: 'USD',
};

// Silent all console logs on production
if (process.env.VUE_APP_URL === 'https://wekeep.app') {
  Vue.config.silent = true;
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
